/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoTrace } from './OutputGeoTrace';
import {
    OutputGeoTraceFromJSON,
    OutputGeoTraceFromJSONTyped,
    OutputGeoTraceToJSON,
} from './OutputGeoTrace';
import type { OutputUavParsePreviewCatalog } from './OutputUavParsePreviewCatalog';
import {
    OutputUavParsePreviewCatalogFromJSON,
    OutputUavParsePreviewCatalogFromJSONTyped,
    OutputUavParsePreviewCatalogToJSON,
} from './OutputUavParsePreviewCatalog';
import type { OutputUavParsePreviewLoiter } from './OutputUavParsePreviewLoiter';
import {
    OutputUavParsePreviewLoiterFromJSON,
    OutputUavParsePreviewLoiterFromJSONTyped,
    OutputUavParsePreviewLoiterToJSON,
} from './OutputUavParsePreviewLoiter';
import type { OutputUavWaypoint } from './OutputUavWaypoint';
import {
    OutputUavWaypointFromJSON,
    OutputUavWaypointFromJSONTyped,
    OutputUavWaypointToJSON,
} from './OutputUavWaypoint';

/**
 * 
 * @export
 * @interface OutputUavParsePreview
 */
export interface OutputUavParsePreview {
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    activeUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    altitude?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    comment?: string;
    /**
     * 
     * @type {OutputUavParsePreviewCatalog}
     * @memberof OutputUavParsePreview
     */
    crew?: OutputUavParsePreviewCatalog;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    destinationArea?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreview
     */
    durationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    flightDate?: string;
    /**
     * Stage 3 (геокодинг).
     * @type {Array<OutputUavWaypoint>}
     * @memberof OutputUavParsePreview
     */
    flightPath?: Array<OutputUavWaypoint>;
    /**
     * GeoError / LoiterError — best-effort кроки: у бойовому прогоні їхня помилка лише в лог,
     * а заявка формалізується далі. На стенді показуємо явно.
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    geoError?: string;
    /**
     * GeoTrace — розбір рішення геокодера: токени маршруту, кандидати газетира на кожен,
     * коридор старт↔ціль і гіпотези beam-search із вартістю.
     * @type {OutputGeoTrace}
     * @memberof OutputUavParsePreview
     */
    geoTrace?: OutputGeoTrace;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    launchSite?: string;
    /**
     * 
     * @type {OutputUavParsePreviewLoiter}
     * @memberof OutputUavParsePreview
     */
    loiter?: OutputUavParsePreviewLoiter;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    loiterError?: string;
    /**
     * Stage 1 (LLM).
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    normalizedPayload?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreview
     */
    parseConfidence?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    parseModel?: string;
    /**
     * Stage 2 (формалізація).
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    parseStatus?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputUavParsePreview
     */
    reviewReasons?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    timeWindow?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreview
     */
    transmitterPlatformId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreview
     */
    uavPlatformId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    uavPlatformName?: string;
    /**
     * 
     * @type {OutputUavParsePreviewCatalog}
     * @memberof OutputUavParsePreview
     */
    unit?: OutputUavParsePreviewCatalog;
    /**
     * 
     * @type {boolean}
     * @memberof OutputUavParsePreview
     */
    usesDroneId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreview
     */
    workType?: string;
}

/**
 * Check if a given object implements the OutputUavParsePreview interface.
 */
export function instanceOfOutputUavParsePreview(value: object): boolean {
    return true;
}

export function OutputUavParsePreviewFromJSON(json: any): OutputUavParsePreview {
    return OutputUavParsePreviewFromJSONTyped(json, false);
}

export function OutputUavParsePreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavParsePreview {
    if (json == null) {
        return json;
    }
    return {
        
        'activeUntil': json['activeUntil'] == null ? undefined : json['activeUntil'],
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'crew': json['crew'] == null ? undefined : OutputUavParsePreviewCatalogFromJSON(json['crew']),
        'destinationArea': json['destinationArea'] == null ? undefined : json['destinationArea'],
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'flightDate': json['flightDate'] == null ? undefined : json['flightDate'],
        'flightPath': json['flightPath'] == null ? undefined : ((json['flightPath'] as Array<any>).map(OutputUavWaypointFromJSON)),
        'geoError': json['geoError'] == null ? undefined : json['geoError'],
        'geoTrace': json['geoTrace'] == null ? undefined : OutputGeoTraceFromJSON(json['geoTrace']),
        'launchSite': json['launchSite'] == null ? undefined : json['launchSite'],
        'loiter': json['loiter'] == null ? undefined : OutputUavParsePreviewLoiterFromJSON(json['loiter']),
        'loiterError': json['loiterError'] == null ? undefined : json['loiterError'],
        'normalizedPayload': json['normalizedPayload'] == null ? undefined : json['normalizedPayload'],
        'parseConfidence': json['parseConfidence'] == null ? undefined : json['parseConfidence'],
        'parseModel': json['parseModel'] == null ? undefined : json['parseModel'],
        'parseStatus': json['parseStatus'] == null ? undefined : json['parseStatus'],
        'reviewReasons': json['reviewReasons'] == null ? undefined : json['reviewReasons'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
        'transmitterPlatformId': json['transmitterPlatformId'] == null ? undefined : json['transmitterPlatformId'],
        'uavPlatformId': json['uavPlatformId'] == null ? undefined : json['uavPlatformId'],
        'uavPlatformName': json['uavPlatformName'] == null ? undefined : json['uavPlatformName'],
        'unit': json['unit'] == null ? undefined : OutputUavParsePreviewCatalogFromJSON(json['unit']),
        'usesDroneId': json['usesDroneId'] == null ? undefined : json['usesDroneId'],
        'workType': json['workType'] == null ? undefined : json['workType'],
    };
}

export function OutputUavParsePreviewToJSON(value?: OutputUavParsePreview | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activeUntil': value['activeUntil'],
        'altitude': value['altitude'],
        'comment': value['comment'],
        'crew': OutputUavParsePreviewCatalogToJSON(value['crew']),
        'destinationArea': value['destinationArea'],
        'durationMs': value['durationMs'],
        'flightDate': value['flightDate'],
        'flightPath': value['flightPath'] == null ? undefined : ((value['flightPath'] as Array<any>).map(OutputUavWaypointToJSON)),
        'geoError': value['geoError'],
        'geoTrace': OutputGeoTraceToJSON(value['geoTrace']),
        'launchSite': value['launchSite'],
        'loiter': OutputUavParsePreviewLoiterToJSON(value['loiter']),
        'loiterError': value['loiterError'],
        'normalizedPayload': value['normalizedPayload'],
        'parseConfidence': value['parseConfidence'],
        'parseModel': value['parseModel'],
        'parseStatus': value['parseStatus'],
        'reviewReasons': value['reviewReasons'],
        'timeWindow': value['timeWindow'],
        'transmitterPlatformId': value['transmitterPlatformId'],
        'uavPlatformId': value['uavPlatformId'],
        'uavPlatformName': value['uavPlatformName'],
        'unit': OutputUavParsePreviewCatalogToJSON(value['unit']),
        'usesDroneId': value['usesDroneId'],
        'workType': value['workType'],
    };
}

